export const my = {
  extends: 'ContentPage',
  metadata: { title: 'My profile / Symbols Workspace' },
  eyebrow: 'Account',
  title: 'My profile',
  sections: [
    { label: 'Profile' },
    { label: 'Availability' },
    { label: 'Equity grant' },
    { label: 'Documents' },
    { label: 'Checklist' },
    { label: 'Security' },
    { label: 'Notifications' },
    { label: 'Sessions' },
    { label: 'Danger zone' }
  ],

  PageBody: {
    flow: 'y',
    flex: '1',
    minWidth: '0',
    MemberProfile: {}
  }
}
